import React, { Component } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
    return {};
};

class Main extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="TopBtnSwLL dataSource">
                <p>データの出典</p>
                <fieldset className="Unit l-mtS">
                    <legend> 地図</legend>

                    <div className="l-row l-mtSS">
                        <label>標準地図　　：</label>
                        <p>国土地理院(https://maps.gsi.go.jp/development/ichiran.htm)</p>
                    </div>
                    <div className="l-row l-mtSS">
                        <label>淡色地図　　：</label>
                        <p>国土地理院(https://maps.gsi.go.jp/development/ichiran.html)</p>
                    </div>
                    <div className="l-row l-mtSS">
                        <label>白地図　　　：</label>
                        <p>国土地理院(https://maps.gsi.go.jp/development/ichiran.html)</p>
                    </div>
                    <div className="l-row l-mtSS">
                        <label>白地図＋陰影：</label>
                        <p>国土地理院(https://maps.gsi.go.jp/development/ichiran.html)</p>
                    </div>
                </fieldset>
                <fieldset className="Unit l-mtS">
                    <legend> 国土（水・土地）</legend>
                    <div className="l-row l-mtSS">
                        <label>流域界：</label>
                        <br />
                        <p>
                            国土交通省（流域界・非集水域データ）
                            <br />
                            (https://nlftp.mlit.go.jp/ksj/gmlold/datalist/gmlold_KsjTmplt-W12.html)をもとに加工
                        </p>
                    </div>
                </fieldset>
                <fieldset className="Unit l-mtS">
                    <legend>ボーリング</legend>
                    <div className="l-row l-mtSS">
                        <label>zenkoku1：</label>
                        <br />
                        <p>
                            国土地盤情報検索サイトKuniJiban
                            <br />
                            (https://www.kunijiban.pwri.go.jp/jp/)をもとに加工
                        </p>
                    </div>
                    <div className="l-row l-mtSS">
                        <label>zenkoku3：</label>
                        <br />
                        <p>
                            ジオ・ステーション
                            <br />
                            (https://www.geo-stn.bosai.go.jp/)をもとに加工
                        </p>
                    </div>
                    <div className="l-row l-mtSS">
                        <label>zenkoku4：</label>
                        <br />
                        <p>
                            全国地下水資料台帳
                            <br />
                            (https://nlftp.mlit.go.jp/kokjo/inspect/landclassification/water/f9_exp.html)をもとに加工
                        </p>
                    </div>
                    <div className="l-row l-mtSS">
                        <p>※出典の記載がないボーリングデータはジーエムラボ独自に収集したデータとなります。</p>
                    </div>
                </fieldset>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Main);
